/**
 * FRSmooth — выравнивание кожи БЕЗ «пластика», и осветление тёмных кругов.
 *
 * ПОЧЕМУ НЕ РАЗМЫТИЕ
 * ──────────────────
 * Все жалобы на бьюти-фильтры сводятся к одному: кожа превращается в резину.
 * Причина всегда одна и та же — размывается ВСЁ, и вместе с пятнами уходят
 * поры, веснушки и щетина, то есть признаки, по которым глаз опознаёт живую
 * кожу. Поэтому здесь размывается не изображение, а ОДНА полоса частот.
 *
 * Раскладка на три полосы (частотное разделение, как у ретушёров):
 *   низ    = сильное размытие          — форма и светотень лица   ← не трогаем
 *   пятна  = среднее минус низ         — неровный тон, покраснения ← ослабляем
 *   деталь = снимок минус среднее      — поры, волоски, щетина     ← НЕ трогаем
 *
 * Итог = низ + пятна·(1−сила) + деталь. При силе 1 исчезают пятна, а поры
 * остаются ПОЛНОСТЬЮ: их частоты в ослабляемой полосе просто отсутствуют.
 * Проверяется числом — среднеквадратичный лапласиан по коже до и после должен
 * оставаться около 100% (у обычного размытия он падает в разы).
 *
 * Радиусы задаются ДОЛЕЙ ШИРИНЫ ЛИЦА, а не пикселями: иначе на портрете
 * крупным планом «пятно» окажется размером с пору, а на общем плане — с щёку.
 */
(function (root) {
    'use strict';

    function boxBlur(src, w, h, r) {
        return root.FREngine.boxBlur(src, w, h, r);
    }
    // Крупный радиус (форма лица, уровень кожи вокруг) — поле гладкое, и
    // движок считает его на грубой сетке с той же дисперсией (FREngine.blurCoarse).
    function blurLow(src, w, h, r) {
        return root.FREngine.blurCoarse ? root.FREngine.blurCoarse(src, w, h, r) : boxBlur(src, w, h, r);
    }

    /**
     * @param {object} pl     линейные плоскости
     * @param {object} model  результат FREngine.analyze (нужны mask и faces)
     * @param {object} p      {strength 0..1, redness 0..1, faceWidth}
     */
    function smoothSkin(pl, model, p) {
        p = p || {};
        var strength = p.strength === undefined ? 0 : p.strength;
        var redness = p.redness === undefined ? 0 : p.redness;
        var w = pl.w, h = pl.h, n = w * h;
        var out = {
            w: w, h: h, clip: pl.clip,
            R: Float32Array.from(pl.R), G: Float32Array.from(pl.G), B: Float32Array.from(pl.B),
        };
        if (!model || !model.ok || (strength <= 0 && redness <= 0)) return out;
        var mask = model.mask;

        // Масштаб от ШИРИНЫ ЛИЦА: пятно на портрете крупным планом и на общем
        // плане — разное число пикселей, но одна и та же доля лица.
        var fw = p.faceWidth || model.faceWidth || 0.35;
        var facePx = Math.max(24, fw * Math.max(w, h));
        var rMid = Math.max(1, Math.round(0.012 * facePx));   // граница «деталь / пятно»
        var rLow = Math.max(rMid + 2, Math.round(0.10 * facePx)); // граница «пятно / форма»

        // Порог «пятно или СТРУКТУРА». Ослаблять всю среднюю полосу нельзя:
        // в неё попадают не только неровности тона, но и оправа очков, родинки,
        // край бороды и линия волос — на полной силе они смазываются в плёнку,
        // и лицо выглядит как маска (проверено глазом, полная сила: оправа
        // очков растворилась). Поэтому ослабление гасится по МОДУЛЮ отклонения:
        // мелкое — выравниваем, крупное — пропускаем нетронутым.
        var lumAll = new Float32Array(n);
        for (var q0 = 0; q0 < n; q0++) lumAll[q0] = 0.2126 * pl.R[q0] + 0.7152 * pl.G[q0] + 0.0722 * pl.B[q0];
        var lumLow = blurLow(lumAll, w, h, rLow);

        var ch = [['R', pl.R], ['G', pl.G], ['B', pl.B]];
        for (var c = 0; c < 3; c++) {
            var name = ch[c][0], src = ch[c][1];
            var mid = boxBlur(src, w, h, rMid);
            var low = blurLow(mid, w, h, rLow);
            var dst = out[name];
            for (var i = 0; i < n; i++) {
                var m = mask[i];
                if (m <= 0.01) continue;
                var detail = src[i] - mid[i];       // поры и волоски — сохраняем
                var blotch = mid[i] - low[i];       // неровный тон — ослабляем
                var thr = Math.max(0.012, (p.structure === undefined ? 0.10 : p.structure) * lumLow[i]);
                var g = Math.exp(-(blotch * blotch) / (thr * thr));   // 1 у пятна, 0 у контура
                var v = low[i] + blotch * (1 - strength * m * g) + detail;
                dst[i] = v < 0 ? 0 : v;
            }
        }

        // Покраснения: гасим ИЗБЫТОК красного над локальным уровнем, а не
        // красный вообще — иначе уходит здоровый румянец и губы бледнеют.
        if (redness > 0) {
            var exR = new Float32Array(n);
            for (var j = 0; j < n; j++) {
                var t = out.R[j] + out.G[j] + out.B[j];
                exR[j] = t > 1e-6 ? out.R[j] / t : 1 / 3;
            }
            var baseR = blurLow(exR, w, h, rLow);
            for (var k = 0; k < n; k++) {
                var mm = mask[k];
                if (mm <= 0.01) continue;
                var over = exR[k] - baseR[k];
                if (over <= 0) continue;            // бледнее нормы — не трогаем
                // ЯРКОСТЬ СОХРАНЯЕТСЯ, меняется только доля красного.
                // Первая версия возвращала снятое из красного в зелёный и синий
                // «чтобы пятно не потемнело» — и обесцвечивала лицо в серую
                // плёнку: добавка шла ВСЕМ пикселям кожи, а не только красным.
                // Правильно — пересобрать пиксель с новой хроматичностью при
                // ТОЙ ЖЕ сумме каналов.
                var t2 = out.R[k] + out.G[k] + out.B[k];
                if (t2 <= 1e-6) continue;
                var cr = exR[k] - over * redness * mm;
                var restG = out.G[k], restB = out.B[k];
                var restSum = restG + restB;
                if (restSum <= 1e-6) continue;
                out.R[k] = cr * t2;
                var left = t2 - out.R[k];
                out.G[k] = left * (restG / restSum);
                out.B[k] = left * (restB / restSum);
            }
        }
        return out;
    }

    /**
     * Мягкость края полосы «под глазами» — от РАМКИ ЛИЦА, а не от кадра.
     *
     * Раньше радиус был 1 % длинной стороны изображения. На видео это и есть
     * доля лица: разбирается область вокруг него (рамка + 28 % с каждой
     * стороны, video-engine regionOf). А /face-retouch разбирает ВЕСЬ снимок,
     * и лицо на нём бывает десятой частью кадра — тогда полоса расплывалась
     * шире самого глаза и осветляла веко и складку НАД глазом. Замер
     * 26.09.2026 (18 лиц, полная сила): утечка выше верхнего века у 13 лиц,
     * 2259 px; с радиусом от рамки — 240 px у 5 (все пять — промахи точек
     * MediaPipe: закрытый глаз, смещённый контур), а масса осветления под
     * глазом та же (−3 %). Число подобрано так, чтобы лицо получало тот же
     * радиус, что дало бы ему видео, — на видео поведение не меняется.
     * Отвергнуто замером: полоса, повёрнутая по оси глаза, — у глаза свой
     * наклон (наружный уголок выше), высота века откалибрована С ним, и
     * повёрнутая полоса молча ослабила эффект в 2.4 раза.
     */
    var UNDER_EYE_SOFT = 0.010 * 1.56;
    function underEyeSoftness(fc, w, h) {
        var b = fc && fc.box;
        var side = b ? Math.max(b.w * w, b.h * h) : 0;
        if (!(side > 0)) return Math.max(3, Math.round(0.010 * Math.max(w, h)));
        return Math.max(3, Math.round(UNDER_EYE_SOFT * side));
    }

    /**
     * Осветление тёмных кругов под глазами. Область берётся от ГЕОМЕТРИИ —
     * прямоугольник под контуром глаза, — а не по «тёмным пикселям»: последнее
     * цепляет ресницы, оправу очков и тень от носа.
     */
    function brightenUnderEye(pl, model, faces, p) {
        p = p || {};
        var amount = p.amount === undefined ? 0 : p.amount;
        var w = pl.w, h = pl.h, n = w * h;
        var out = {
            w: w, h: h, clip: pl.clip,
            R: Float32Array.from(pl.R), G: Float32Array.from(pl.G), B: Float32Array.from(pl.B),
        };
        if (amount <= 0 || !faces || !faces.length || !model || !model.ok) return out;

        // Полоса каждого лица размывается СВОИМ радиусом (underEyeSoftness) —
        // у лиц разного размера он разный; полосы разных лиц не пересекаются,
        // поэтому их объединение — максимум.
        var zone = new Float32Array(n), soft = null;
        var blurS = root.FREngine.boxBlurSparse || boxBlur;
        for (var f = 0; f < faces.length; f++) {
            var fc = faces[f];
            if (f > 0) zone.fill(0);
            [fc.leftEye, fc.rightEye].forEach(function (eye) {
                if (!eye || eye.length < 4) return;
                // Полоса строится по НИЖНЕМУ веку. Контур глаза теперь полный
                // (landmarks.js: первые 9 точек — нижнее веко), а полоса
                // откалибрована по высоте нижнего века: по всему глазу она
                // выросла бы вдвое — та самая «светлая плашка как грим».
                if (eye.length >= 16) eye = eye.slice(0, 9);
                var minX = 1, maxX = 0, minY = 1, maxY = 0;
                for (var q = 0; q < eye.length; q++) {
                    if (eye[q][0] < minX) minX = eye[q][0];
                    if (eye[q][0] > maxX) maxX = eye[q][0];
                    if (eye[q][1] < minY) minY = eye[q][1];
                    if (eye[q][1] > maxY) maxY = eye[q][1];
                }
                var ew = maxX - minX, eh = maxY - minY;
                // Полоса ПОД глазом: от нижнего века вниз на ~1.6 высоты глаза.
                // Полоса узкая и короткая. Первая версия брала 1.6 высоты
                // глаза во всю ширину — под глазами появлялась светлая плашка,
                // которую видно как грим. Круги лежат сразу под веком.
                var poly = [
                    [minX + ew * 0.02, maxY - eh * 0.05],
                    [maxX - ew * 0.02, maxY - eh * 0.05],
                    [maxX - ew * 0.14, maxY + eh * 0.85],
                    [minX + ew * 0.14, maxY + eh * 0.85],
                ];
                root.FREngine.fillPoly(zone, w, h, poly, 1, 0);
            });
            var sf = blurS(zone, w, h, underEyeSoftness(fc, w, h));
            if (!soft) soft = sf;
            else for (var q2 = 0; q2 < n; q2++) if (sf[q2] > soft[q2]) soft[q2] = sf[q2];
        }

        // Целевой уровень — кожа ВОКРУГ, а не абстрактное осветление.
        var lum = new Float32Array(n);
        for (var i = 0; i < n; i++) lum[i] = 0.2126 * pl.R[i] + 0.7152 * pl.G[i] + 0.0722 * pl.B[i];
        var ref = blurLow(lum, w, h, Math.max(6, Math.round(0.05 * Math.max(w, h))));

        for (var z = 0; z < n; z++) {
            var a = soft[z] * model.mask[z];
            if (a <= 0.01) continue;
            var cur = lum[z];
            if (cur >= ref[z]) continue;            // не темнее окружения — не трогаем
            var k = 1 + (ref[z] / Math.max(cur, 1e-5) - 1) * amount * a;
            if (k > 1.35) k = 1.35;                 // потолок: круги не должны СВЕТИТЬСЯ
            out.R[z] = pl.R[z] * k; out.G[z] = pl.G[z] * k; out.B[z] = pl.B[z] * k;
        }
        return out;
    }

    root.FRSmooth = { smoothSkin: smoothSkin, brightenUnderEye: brightenUnderEye };
})(typeof window !== 'undefined' ? window : globalThis);
